import { ActiveState, EntityState, EntityStore } from '@datorama/akita';
import { OrderListItemModel } from '../../../models/order/order-list-item.model';

/**
 * Define entity state here with additional information.
 */
export interface OrderItemsState
  extends EntityState<OrderListItemModel, number>,
    ActiveState {
  page: number;
  pageSize: number;
  lastPage: boolean;
}

// @Injectable({
//     providedIn: 'root'
// })
// @StoreConfig({name: 'order-items', idKey: 'orderID'})
export class OrderItemsStore extends EntityStore<OrderItemsState> {
  constructor(storeName: string) {
    super(
      {
        page: 0,
        pageSize: 150,
        lastPage: false,
      },
      { name: storeName, idKey: 'orderID' }
    );
  }
}
